import { a3Copy } from "@/components/assignments/a3-copy";
import { useContext } from "react";
import { HandInWork } from "@/components/session/handin/HandInWork";
import { WorkBox } from "./coursework/WorkBoxHost";
import type { SemesterStatus } from "@/lib/api/academicStructure";
import type { Assignment, AssignmentDetail, Submission } from "@/lib/api/assignments";
import { isHistoricalTerm } from "@/lib/term-state";
import { AssignmentTimezone } from "./assignment-workspace-context";

/** Course-wide work shares the session box. The course owner still resolves
 * scoped receipt addresses before this component reads their attempt thread. */
export function LearnerAssignmentDetail({ assignment, term, attempts, attemptsPending, attemptsFailed, onRetryAttempts, receipt, onSubmitted }: {
  assignment: Assignment;
  term: { name: string | null; status: SemesterStatus | null };
  attempts: Submission[];
  attemptsPending: boolean;
  attemptsFailed: boolean;
  onRetryAttempts: () => void;
  receipt?: Submission;
  onSubmitted?: (receipt: Submission) => void;
  onSelectReceipt?: (id: string) => void;
}) {
  const timezone = useContext(AssignmentTimezone) ?? "UTC";
  const detail = "versions" in assignment && Array.isArray(assignment.versions) ? assignment as AssignmentDetail : undefined;
  if (attemptsPending || attemptsFailed) return <WorkBox box={{ kind: "fact", id: `hand-in-${assignment.id}`, label: a3Copy.handIn, job: a3Copy.readYourOwnAttemptsBeforeChoosingAHandIn, owner: { system: "imam" }, fold: "never", detail: () => "", read: attemptsFailed ? { status: "failed", sentence: a3Copy.yourAttemptsCouldNotBeRead, retry: onRetryAttempts } : { status: "loading" } }} />;
  return <HandInWork assignmentId={assignment.id} title={assignment.title} timezone={timezone}
            termOpen={!isHistoricalTerm(term.status)} termName={term.name} pastDue={detail?.past_due ?? false}
            filled ownPage selectedAttemptId={receipt?.id} initialTerms={detail} initialAttempts={attempts} onSubmitted={onSubmitted} />;
}
